// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t4p3","content":"styles_content__Uo0bo"};